import React from 'react';

export const IconBlockedUser: React.FC = () => {
    return (
        <svg
            width='153.083008'
            height='154.115234'
            viewBox='0 0 153.083 154.115'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <defs>
                <filter
                    id='filter_2143_93187_dd'
                    x='20.112793'
                    y='0.000000'
                    width='129.677734'
                    height='154.115234'
                    filterUnits='userSpaceOnUse'
                    color-interpolation-filters='sRGB'>
                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                        in='SourceAlpha'
                        type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                    />
                    <feOffset dx='0' dy='11' />
                    <feGaussianBlur stdDeviation='7.33333' />
                    <feComposite in2='hardAlpha' operator='out' k2='-1' k3='1' />
                    <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.39608 0 0 0 0 0.47843 0 0 0 0 0.57647 0 0 0 0.27 0'
                    />
                    <feBlend mode='normal' in2='BackgroundImageFix' result='effect_dropShadow_1' />
                    <feBlend mode='normal' in='SourceGraphic' in2='effect_dropShadow_1' result='shape' />
                </filter>
                <linearGradient
                    x1='84.923820'
                    y1='8.452934'
                    x2='84.923820'
                    y2='122.302429'
                    id='paint_linear_2143_93187_0'
                    gradientUnits='userSpaceOnUse'>
                    <stop stop-color='#FDFEFF' />
                    <stop offset='0.996400' stop-color='#ECF0F5' />
                </linearGradient>
            </defs>
            <path
                id='Vector'
                d='M85.07 130.71C118.95 130.71 146.42 103.12 146.42 68.97C146.42 34.82 118.83 7.23 85.07 7.23C51.18 7.23 23.71 34.82 23.71 68.97C23.71 103.12 51.18 130.71 85.07 130.71Z'
                fill='#EAEEF9'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M147.39 23.51C147.39 26.27 145.17 28.5 142.43 28.5C139.69 28.5 137.47 26.27 137.47 23.51C137.47 20.76 139.69 18.53 142.43 18.53C145.17 18.53 147.39 20.76 147.39 23.51Z'
                fill='#EAEEF9'
                fill-opacity='1.000000'
                fill-rule='evenodd'
            />
            <path
                id='Vector'
                d='M153.08 5.65C153.08 7.53 151.56 9.05 149.69 9.05C147.82 9.05 146.3 7.53 146.3 5.65C146.3 3.77 147.82 2.24 149.69 2.24C151.56 2.24 153.08 3.77 153.08 5.65Z'
                fill='#EAEEF9'
                fill-opacity='1.000000'
                fill-rule='evenodd'
            />
            <path
                id='Vector'
                d='M30.37 24.97C30.37 26.85 28.85 28.38 26.98 28.38C25.11 28.38 23.59 26.85 23.59 24.97C23.59 23.09 25.11 21.57 26.98 21.57C28.85 21.57 30.37 23.09 30.37 24.97Z'
                fill='#EAEEF9'
                fill-opacity='1.000000'
                fill-rule='evenodd'
            />
            <path
                id='Vector'
                d='M12.58 87.69C12.58 91.18 9.76 94.01 6.29 94.01C2.81 94.01 0 91.18 0 87.69C0 84.2 2.81 81.37 6.29 81.37C9.76 81.37 12.58 84.2 12.58 87.69Z'
                fill='#EAEEF9'
                fill-opacity='1.000000'
                fill-rule='evenodd'
            />
            <g filter='url(#filter_2143_93187_dd)'>
                <path
                    id='Vector'
                    d='M126.82 38.1L127.79 116.37C127.79 119.04 125.61 121.11 122.95 121.11L46.95 121.11C44.29 121.11 42.11 118.92 42.11 116.37L42.11 15.74C42.11 13.06 44.29 11 46.95 11L102.01 11L126.82 38.1Z'
                    fill='url(#paint_linear_2143_93187_0)'
                    fill-opacity='1.000000'
                    fill-rule='nonzero'
                />
            </g>
            <path
                id='Vector'
                d='M79.14 105.43L64.25 105.43C63.65 105.43 63.16 104.82 63.16 104.1C63.16 103.37 63.65 102.76 64.25 102.76L79.14 102.76C79.74 102.76 80.23 103.37 80.23 104.1C80.23 104.95 79.74 105.43 79.14 105.43Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M70.67 105.43L54.45 105.43C53.85 105.43 53.36 104.82 53.36 104.1C53.36 103.37 53.85 102.76 54.45 102.76L70.67 102.76C71.27 102.76 71.76 103.37 71.76 104.1C71.76 104.95 71.27 105.43 70.67 105.43Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M91.36 27.4L54.93 27.4C54.09 27.4 53.36 26.67 53.36 25.82C53.36 24.97 54.09 24.24 54.93 24.24L91.36 24.24C92.21 24.24 92.93 24.97 92.93 25.82C92.93 26.67 92.21 27.4 91.36 27.4Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M68.97 36.15L54.93 36.15C54.09 36.15 53.36 35.42 53.36 34.57C53.36 33.72 54.09 32.99 54.93 32.99L68.85 32.99C69.7 32.99 70.42 33.72 70.42 34.57C70.42 35.42 69.7 36.15 68.97 36.15Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M102.01 11L102.01 32.63C102.01 35.67 104.67 38.1 107.7 38.1L126.82 38.1L102.01 11Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M116 84.4L74.01 84.4L69.39 84.4L55.39 84.4C54.83 84.4 54.26 84.97 54.26 85.76C54.26 86.44 54.71 87.12 55.39 87.12L69.39 87.12L74.01 87.12L116 87.12C116.57 87.12 117.13 86.56 117.13 85.76C117.02 84.97 116.57 84.4 116 84.4Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M115.89 74.51L100.31 74.51L95.01 74.51L55.39 74.51C54.83 74.51 54.26 75.08 54.26 75.88C54.26 76.56 54.71 77.24 55.39 77.24L95.01 77.24L100.31 77.24L115.89 77.24C116.45 77.24 117.02 76.67 117.02 75.88C116.91 75.08 116.45 74.51 115.89 74.51Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M116.23 64.52L112.16 64.52L108.1 64.52L55.39 64.52C54.83 64.52 54.26 65.09 54.26 65.88C54.26 66.56 54.71 67.25 55.39 67.25L108.1 67.25L112.62 67.25L116.12 67.25C116.68 67.25 117.24 66.68 117.24 65.88C117.36 65.2 116.79 64.52 116.23 64.52Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M71.98 106.44L55.39 106.44C54.83 106.44 54.26 105.87 54.26 105.07C54.26 104.39 54.71 103.71 55.39 103.71L71.98 103.71C72.55 103.71 73.11 104.28 73.11 105.07C73.11 105.98 72.55 106.44 71.98 106.44Z'
                fill='#E3EAF2'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M116.68 54.64L103.47 54.64L100.2 54.64L55.39 54.64C54.83 54.64 54.26 55.2 54.26 56C54.26 56.68 54.71 57.36 55.39 57.36L100.2 57.36L103.47 57.36L116.57 57.36C117.36 57.36 117.81 56.79 117.81 56C117.81 55.32 117.36 54.64 116.68 54.64Z'
                fill='#D5DDEA'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M56.29 112.46L29.66 112.46C26.72 112.46 24.35 110.07 24.35 107.12L24.35 69.97C24.35 59.63 32.7 51.34 42.86 51.34C53.02 51.34 61.37 59.75 61.37 69.97L61.37 107.23C61.49 110.07 59.12 112.46 56.29 112.46ZM34.96 101.89L50.99 101.89L50.99 69.97C50.99 65.54 47.38 61.9 42.98 61.9C38.57 61.9 34.96 65.54 34.96 69.97L34.96 101.89Z'
                fill='#989FB0'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M67.24 122.57L19.05 122.57C15.77 122.57 13.06 119.84 13.06 116.55L13.06 84.4C13.06 81.1 15.77 78.38 19.05 78.38L67.24 78.38C70.51 78.38 73.22 81.1 73.22 84.4L73.22 116.55C73.22 119.84 70.51 122.57 67.24 122.57Z'
                fill='#C2C8D6'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
            <path
                id='Vector'
                d='M49.18 95.53C49.18 97.92 47.83 99.96 45.91 100.99L45.91 107.57C45.91 109.16 44.67 110.41 43.09 110.41C41.51 110.41 40.27 109.16 40.27 107.57L40.27 100.99C38.35 99.96 36.99 97.92 36.99 95.53C36.99 92.12 39.7 89.4 43.09 89.4C46.47 89.4 49.18 92.12 49.18 95.53Z'
                fill='#989FB0'
                fill-opacity='1.000000'
                fill-rule='nonzero'
            />
        </svg>
    );
};
